function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useEffect, useRef, useState } from 'react';
import { createPopper } from '@popperjs/core/lib/popper-lite';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import { isBrowser, isMobile } from '../../utils';
var STATE_INDICATOR_KEY = 'isTooltipHistoryEntry';
export function usePopper(popperConfig) {
  var updateProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isOpenProp = arguments.length > 2 ? arguments[2] : undefined;
  var targetRef = arguments.length > 3 ? arguments[3] : undefined;
  var _useState = useState(isOpenProp),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var popperInstance = useRef();
  var triggerRef = useRef(null);
  var popupRef = useRef(null);
  var innerRef = useRef(null);
  function onPopState(event) {
    // @ts-ignore
    if (!event.singleSpa) setIsOpen(false);
    //  single-spa тригерит событие popstate в ответ на pushState()
  }

  function create() {
    if (triggerRef.current && popupRef.current) {
      var _targetRef$current;
      var popper = createPopper((_targetRef$current = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) !== null && _targetRef$current !== void 0 ? _targetRef$current : triggerRef.current, popupRef.current, popperConfig || {});
      popper.forceUpdate();
      popperInstance.current = popper;
      if (isBrowser) {
        window.addEventListener('popstate', onPopState);
      }
    } else {
      throw new Error('Tooltip: triggerRef.current or popupRef.current are not defined (wrap trigger`s component in React.ForwardRef)');
    }
  }
  function destroy() {
    if (popperInstance.current) {
      popperInstance.current.destroy();
      popperInstance.current = null;
    }
    if (isBrowser) {
      window.removeEventListener('popstate', onPopState);
    }
  }
  var showHandler = useCallback(function () {
    setIsOpen(true);
    if (isMobile() && isBrowser) {
      window.history.pushState(_defineProperty({}, STATE_INDICATOR_KEY, true), '');
    }
  }, [isOpen]);
  var hideHandler = useCallback(function () {
    setIsOpen(false);
    if (isMobile() && isBrowser) {
      setTimeout(function () {
        var isTooltipEntry = !!window.history.state[STATE_INDICATOR_KEY];
        // Тултип может содержать ссылки, модифицирующие историю, из-за чего возникает следующая ситуация:
        // тултип пушит вспомогательную запись в историю - в самом тултипе мы переходим по ссылке - что в свою
        // очередь пушит еще одну запись - при закрытии тултипа вызываем history.back - и неожиданно откатываем
        // запись которая появилась при переходе по ссылке
        // Данной проверкой удостоверяемся что не возникло новых записей которые мы можем затереть
        if (isTooltipEntry) window.history.back();
      }, 100);
    }
  }, [isOpen]);
  useEffect(function () {
    if (!isOpen) return destroy;
    var timeoutMount = setTimeout(create, 100);
    return function () {
      clearTimeout(timeoutMount);
    };
  }, []);
  useEffect(function () {
    if (isOpen) {
      var _popperInstance$curre;
      (_popperInstance$curre = popperInstance.current) === null || _popperInstance$curre === void 0 ? void 0 : _popperInstance$curre.forceUpdate();
    }
  }, [isOpen, popperInstance].concat(_toConsumableArray(updateProps)));
  useOutsideClick([innerRef, triggerRef], isOpen, function () {
    hideHandler();
  });
  return {
    triggerRef: triggerRef,
    popupRef: popupRef,
    innerRef: innerRef,
    isOpen: isOpen,
    showHandler: showHandler,
    hideHandler: hideHandler,
    create: create,
    destroy: destroy
  };
}
//# sourceMappingURL=usePopper.js.map